import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import GiftBillingForm from '../forms/GiftBillingForm'
import { selectors } from '../reducer'
import * as apiActions from 'api-actions'
import * as actions from '../actions'
import { COUNTRY, PATH, makeGiftStepsPath } from 'config'
import { GiftContactType } from 'types'
import { handleSubmitFailWithFlashMessage } from 'utils'

const propTypes = {
  autoCompleteAddress: PropTypes.func.isRequired,
  billingContact: GiftContactType,
  fetchPlaceDetails: PropTypes.func.isRequired,
  setBillingContact: PropTypes.func.isRequired,
}

const DEFAULT_BILLING_CONTACT = {
  country: COUNTRY.UNITED_STATES,
}

function Billing({
  autoCompleteAddress,
  billingContact = null,
  fetchPlaceDetails,
  setBillingContact,
}) {
  const history = useHistory()

  const handleSubmit = ({ billingContact }) => {
    setBillingContact(billingContact)
  }

  return (
    <GiftBillingForm
      autoCompleteAddress={autoCompleteAddress}
      fetchPlaceDetails={fetchPlaceDetails}
      enableReinitialize={true}
      initialValues={{
        billingContact: billingContact ?? DEFAULT_BILLING_CONTACT,
      }}
      onSubmit={handleSubmit}
      onSubmitFail={handleSubmitFailWithFlashMessage}
      onSubmitSuccess={() => history.push(makeGiftStepsPath(PATH.PAYMENT))}
    />
  )
}

Billing.propTypes = propTypes

function mapStateToProps(state) {
  return {
    billingContact: selectors.billingContact(state),
  }
}

const mapDispatchToProps = {
  autoCompleteAddress: apiActions.autoCompleteAddress,
  fetchPlaceDetails: apiActions.fetchPlaceDetails,
  setBillingContact: actions.setBillingContact,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Billing)
